import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { PlusIcon } from '@phosphor-icons/react'

import { Button, CombinatorChip, Divider } from '@reveni-io/reveni-ui'

import { initCriterion } from '../constants'
import CriterionEditor from './CriterionEditor/CriterionEditor'
import * as Styles from './styles'

const CriteriaEditor = ({
  criteria,
  properties,
  onChange,
  disabled,
  errorCriteriaIndexes = [],
  canAddCriteria,
  currencies,
  storeCurrencyCode,
  inputBackgroundColor,
}) => {
  const { t } = useTranslation()

  const showAddButton = canAddCriteria && !disabled

  const handleChangeCriterion = (criterionIndex, updatedCriterion) => {
    onChange(criteria.map((criterion, i) => (i === criterionIndex ? updatedCriterion : criterion)))
  }

  const handleRemoveCriterion = criterionIndex => {
    onChange(criteria.filter((_, i) => i !== criterionIndex))
  }

  const handleAddCriterion = () => onChange([...criteria, initCriterion])

  return (
    <Styles.Container>
      {criteria.map((criterion, criterionIndex) => (
        <Fragment key={criterionIndex}>
          {criterionIndex > 0 && (
            <Styles.Separator>
              <CombinatorChip variant="AND" />
            </Styles.Separator>
          )}
          <CriterionEditor
            criterion={criterion}
            index={criterionIndex}
            properties={properties}
            onChange={handleChangeCriterion}
            onRemove={criterionIndex > 0 && (() => handleRemoveCriterion(criterionIndex))}
            disabled={disabled}
            hasError={errorCriteriaIndexes.includes(criterionIndex)}
            currencies={currencies}
            storeCurrencyCode={storeCurrencyCode}
            inputBackgroundColor={inputBackgroundColor}
          />
        </Fragment>
      ))}
      {showAddButton && (
        <>
          <Divider />
          <Styles.AddButtonRow>
            <Button variant="text" size="s" onClick={handleAddCriterion}>
              <PlusIcon size={16} />
              {t('Añadir propiedad')}
            </Button>
          </Styles.AddButtonRow>
        </>
      )}
    </Styles.Container>
  )
}

export default CriteriaEditor
